import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { Navigation } from './components/Navigation'
import { Footer } from './components/Footer'
import { ProtectedRoute } from './components/ProtectedRoute'
import { ScrollToTop } from './components/ScrollToTop'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import PWAUpdateNotification from './components/PWAUpdateNotification'
import PWAInfoBanner from './components/PWAInfoBanner'
import PWAInstructionsModal from './components/PWAInstructionsModal'
import { Home } from './pages/Home'
import { TourDetail } from './pages/TourDetail'
import { Contact } from './pages/Contact'
import { Registration } from './pages/Registration'
import { AdminLogin } from './pages/AdminLogin'
import { AdminDashboard } from './pages/AdminDashboard'
import { Hotels } from './pages/Hotels'
import { HotelDetail } from './pages/HotelDetail'
import { Testimonials } from './pages/Testimonials'

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <div className="min-h-screen bg-background text-foreground">
              <Navigation />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tour/:id" element={<TourDetail />} />
                  <Route path="/hotels" element={<Hotels />} />
                  <Route path="/hotel/:id" element={<HotelDetail />} />
                  <Route path="/testimonials" element={<Testimonials />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/compliance" element={<Registration />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route 
                    path="/admin" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
              </main>
              <Footer />
              <PWAInstallPrompt />
              <PWAUpdateNotification />
              <PWAInfoBanner />
            </div>
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  )
}

export default App
